import axios from 'axios'
import { EntityOutputDTO } from './entityDTO'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class EntityServices {
  async getById(id: number): Promise<EntityOutputDTO> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/entity/${id}`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
  async getByAll(): Promise<EntityOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/entity`,
      {
        headers: { 'authentication-token': getJWT()! },
        params: {
          limit: 999,
        }
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
}

export const entityServices = new EntityServices()
